import styles from './styles.module.css';

type FixedActionsBarProps = React.PropsWithChildren<{
  /** Centre le conteneur d'actions sur l'axe horizontal (utile quand plusieurs boutons doivent rester centrés). */
  centered?: boolean;
  /** Empile les actions sous 900 px, la dernière (l'action principale) en haut : pour des libellés trop longs pour tenir côte à côte. */
  stackOnMobile?: boolean;
}>;

const FixedActionsBar = ({ children, centered = false, stackOnMobile = false }: FixedActionsBarProps) => {
  const classNames = [styles.actionsContainer];
  if (centered) classNames.push(styles.centered);
  if (stackOnMobile) classNames.push(styles.stackOnMobile);
  return (
    <div className={styles.fixedActionsBar}>
      <div className={classNames.join(' ')}>{children}</div>
    </div>
  );
};

export default FixedActionsBar;
